import React from 'react'
import { Badge } from 'antd'
import Text from 'antd/es/typography/Text'
import { useThemeColors } from '../../../../../../../../hooks/useThemeColors'

const SimilarityCell = ({ value, isDivergent }) => {
    const colors = useThemeColors()
    const color = isDivergent || value < 70 ? colors.error : colors.success
    return (
        <>
            <Badge color={color} />
            <Text style={{ marginLeft: 8 }}>{value}%</Text>
        </>
    )
}

export default SimilarityCell


